
import React from 'react';
import { User, SiteTheme } from '../../../types';

export interface HeroVariantProps {
    student?: User;
    className?: string; // New: Class name to display
    title?: string;
    text?: string;
    imageUrl?: string;
    mobileImageUrl?: string;
    videoUrl?: string;
    theme?: SiteTheme;
    
    // Style Props
    titleColor?: string;
    textColor?: string;
    
    // Effects & Textures
    titleShadowClass?: string; 
    textShadowClass?: string;
    heroTitleTexture?: string;
    
    // Text Outline (Stroke)
    heroTitleOutlineWidth?: 'none' | 'sm' | 'md' | 'lg';
    heroTitleOutlineColor?: string;
    heroTextOutlineWidth?: 'none' | 'sm' | 'md';
    heroTextOutlineColor?: string;

    titleSizeClass?: string;
    subtitleSizeClass?: string;
    heightClass?: string;
    
    // Positioning Props
    heroTextAlignment?: 'left' | 'center' | 'right';
    heroContentPosition?: number; // 0 to 100 (X)
    heroContentPositionY?: number; // 0 to 100 (Y)
    
    // Button Styling
    heroButtonColor?: string;
    heroButtonTextColor?: string;

    // Logic
    onScrollToShop?: () => void;
    parallaxRef?: React.RefObject<HTMLDivElement>;

    // Custom Slots
    customButtons?: React.ReactNode;
    customBadge?: React.ReactNode;
}

export const getEffectiveColor = (savedColor: string | undefined, fallback: string) => {
    return savedColor || fallback;
};

// --- HELPER: TEXTURES ---
export const getTextureClass = (type?: string) => {
    switch (type) {
        case 'gold': return 'bg-gradient-to-b from-[#F7E088] via-[#D4AF37] to-[#8A6E36] bg-clip-text text-transparent';
        case 'coffee': return 'bg-gradient-to-b from-[#4A3228] to-[#1A120B] bg-clip-text text-transparent';
        case 'silver': return 'bg-gradient-to-b from-[#F3F4F6] via-[#D1D5DB] to-[#9CA3AF] bg-clip-text text-transparent';
        case 'gradient': return 'bg-gradient-to-r from-coffee-600 to-amber-600 bg-clip-text text-transparent';
        default: return '';
    }
};

// --- HELPER: OUTLINES (Text Stroke) ---
export const getOutlineStyle = (width?: string, color?: string) => {
    if (!width || width === 'none') return {};
    
    const w = width === 'sm' ? '1px' : width === 'md' ? '2px' : '3px';
    const c = color || 'currentColor';
    
    return {
        WebkitTextStroke: `${w} ${c}`,
        textStroke: `${w} ${c}`
    } as React.CSSProperties;
};
